import { createFileRoute, Link } from "@tanstack/react-router";
import AppLogo from "@/components/app-logo";
import { AppInstructions } from "@/components/app-instructions";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { useAuth } from "@/hooks/use-auth";
import { Trees, UserPlus2 } from "lucide-react";
import { reactiveObserver } from "@legendapp/state/react";

export const Route = createFileRoute("/")({
	component: reactiveObserver(HomeComponent),
});

function HomeComponent() {
	const { setupCompleted, login } = useAuth();


	return (
		<div className="container m-auto max-w-3xl px-4 py-2">
			<div className="flex flex-col items-center justify-center gap-2">
				<AppLogo />
				<AppInstructions />
				<Separator className="my-2" />
				{setupCompleted ? (
					<div className="flex flex-1 items-center justify-center gap-2">
						<Button variant="outline" className="flex-1/2" asChild>
							<Link to="/outgrower-farmer-onboarding">Register Farmers <UserPlus2 className="size-4" /></Link>
						</Button>
					</div>
				) : (
					<Button onClick={login}>Complete Setup</Button>
				)}
			</div>
		</div>
	);
}
